import { fetchData } from "./fetch";

export const getAgencies = (data) => fetchData('GET', '/agencies', data);

export const createAgency = (data) => fetchData('POST', '/agencies', data, {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

export const removeAgency = (id) => fetchData('DELETE', `/agencies/${id}`);

export const getAgencyById = (id) => fetchData('GET', `/agencies/${id}`);

export const getAgencyManagers = (id) => fetchData('GET', `/agencies/${id}/managers`);

export const updateAgency = ({ data, id }) => fetchData('PUT', `/agencies/${id}`, data);
